const API_KEY_STORAGE = "protv-converter:youtube-api-key:v1";
const LEGACY_API_KEY_STORAGE = "protv-convertor:youtube-api-key:v1";

export function readApiKey(): string {
  try {
    const currentValue = localStorage.getItem(API_KEY_STORAGE) ?? "";
    const legacyValue = localStorage.getItem(LEGACY_API_KEY_STORAGE) ?? "";
    localStorage.removeItem(LEGACY_API_KEY_STORAGE);
    if (currentValue) return currentValue;
    if (legacyValue) localStorage.setItem(API_KEY_STORAGE, legacyValue);
    return legacyValue;
  } catch {
    return "";
  }
}

export function writeApiKey(value: string): void {
  try {
    if (value) localStorage.setItem(API_KEY_STORAGE, value);
    else localStorage.removeItem(API_KEY_STORAGE);
    localStorage.removeItem(LEGACY_API_KEY_STORAGE);
  } catch {
    // The app still works for manual and file imports when storage is blocked.
  }
}
